export default function PageShell({ title, subtitle, children, action = null }) {
  return (
    <div className="animate-fade-in">
      <div className="flex items-start justify-between mb-8">
        <div>
          <h2 className="text-2xl font-bold text-heading">{title}</h2>
          {subtitle && <p className="text-muted text-sm mt-1">{subtitle}</p>}
        </div>
        {action && <div>{action}</div>}
      </div>
      {children}
    </div>
  )
}
